import { useEffect, useRef, useState } from 'react';
import { depositUserWallet } from '../../services/UsersService';

function apiError(err) {
    const raw = err?.response ? err.response.data : err?.message;
    if (typeof raw === 'string') return raw;
    if (raw && raw.message) return raw.message;
    return raw ? JSON.stringify(raw) : 'Não foi possível registrar o depósito.';
}

function DepositModal({ data, onSubmit }) {
    const closeRef = useRef(null);
    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const userId = data?.user?.id || data?.id;
    const deposited = Number(data?.depositedUsdc ?? data?.allocation);

    useEffect(() => {
        setAmount('');
        setError('');
    }, [userId, data?.depositedUsdc, data?.custodyUsdc]);

    function onSave() {
        if (!userId) return;
        const parsed = parseFloat(amount);
        if (!Number.isFinite(parsed) || !(parsed > 0)) {
            setError('Informe um valor em USDC maior que zero.');
            return;
        }

        setSaving(true);
        setError('');
        depositUserWallet(userId, parsed)
            .then(result => {
                setSaving(false);
                setAmount('');
                closeRef.current?.click();
                if (onSubmit) onSubmit(result);
            })
            .catch(err => {
                setSaving(false);
                setError(apiError(err));
            });
    }

    return (
        <div className="modal fade" id="modalDeposit" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title">Depositar USDC</p>
                        <button ref={closeRef} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <p className="text-muted small mb-3">
                            O valor entra na carteira do usuário e no capital depositado.
                            O app não trata esse crédito como lucro no PnL.
                        </p>
                        {Number.isFinite(deposited)
                            ? (
                                <p className="text-muted small mb-3">
                                    Capital depositado hoje: {deposited.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })} USDC
                                </p>
                            )
                            : <></>}
                        <div className="mb-3">
                            <label htmlFor="depositUsdc" className="form-label">Valor do depósito (USDC)</label>
                            <input
                                id="depositUsdc"
                                type="number"
                                min="0.01"
                                step="0.01"
                                className="form-control"
                                value={amount}
                                onChange={event => setAmount(event.target.value)}
                                placeholder="0.00"
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        {error
                            ? <div className="alert alert-danger mt-1 col-9 py-1 mb-0">{error}</div>
                            : <></>}
                        <button type="button" className="btn btn-sm btn-primary" onClick={onSave} disabled={saving || !userId}>
                            {saving ? 'Depositando...' : 'Depositar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DepositModal;
